export default __webpack_public_path__ + "static/media/addAttribute.d9f8d7ed.svg";